<template>
    <div id="detail-doctor">
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-12"><h4 class="smalltitle">WikiAllergies EMR EPCS Standard Operation Procedure</h4></div>
                </div>
            </div>
            <div class="">
                <p style="text-align: center; font-weight: bolder; font-size: 20px">WikiAllergies EMR EPCS Standard Operation Procedure</p>
                <p>1. Objective</p>
                <ul>
                  <li>1.1 This Standard Operating Procedure (SOP) describes the standard procedure for staff regarding handling of Electronic Prescription for Controlled Substance (EPCS) for WikiAllergies Staff.</li>
                </ul>
                <p>2. EPCS Activation</p>
                <ul>
                  <li>2.1 Verify provider DEA and expiration date. DEA license is uploaded by the practioner at his/her WikiAllergies account or by clinic staff at Security page. Expiration date is declared by user at each uploaded DEA.</li>
                  <li>2.2 Activate EPCS for the practioner if DEA license present and not expired</li>
                  <li>
                    2.3 Activation of EPCS will be done at <a href="https://sales.wikiallergies.com">sales.wikiallergies.com</a> and requiring these steps
                    <ul>
                      <li>2.3.1 From Surescripts Status, open the e-Rx and EPCS window</li>
                      <li>2.3.2 Add "ControlledSubstance" to the "Service Levels" box then clinic Submit for Approval</li>
                      <li>
                        2.3.3 Verification process requiring two WikiAllergies staff signature requiring 2FA and at lease one user holding an active DEA license
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>3. EPCS Deactivation</p>
                <ul>
                  <li>3.1 WikiAllergies EMR automatically block user’s ability to send controlled substance the declared DEA license is expired.</li>
                  <li>3.2 WikiAllergies will notify user to update their DEA license</li>
                  <li>3.3 WikiAllergies staff will randomly audit declared DEA license expiration date</li>
                  <li>3.4 WikiAllergies staff disable EPCS if there is false statement and notify user of discrepancy in their declaration of DEA license or being notified that the practioner’s DEA is revoked.</li>
                  <li>
                    3.5 Deactivation of EPCS will be done at sales. <a href="https://wikiallergies.com">wikiallergies.com</a> by the same step as at 2.3
                    <ul>
                      <li>3.5.1 From Surescripts Status, open the e-Rx and EPCS window</li>
                      <li>3.5.2 Remove "ControlledSubstance" to the "Service Levels" box then clinic Submit for Approval</li>
                      <li>3.5.3 Verification process requiring two WikiAllergies staff signature requiring 2FA and at lease one user holding an active DEA license</li>
                    </ul>
                  </li>
                </ul>
                <p>4.Record keeping of incidents: notification of expired DEA, revoked DEA or discrepancy in DEA declaration</p>
                <ul>
                  <li>
                    4.1 Each incident would automatically log at EPCS incident page
                  </li>
                  <li>
                    4.2 WikiAllergies staff would upload relevance document to each report
                  </li>
                </ul>
                <p>5 iBeta will audit EPCS compliance every two years</p>
                <ul>
                  <li>5.1 In the event of losing EPCS compliant, WikiAllergies staff would follow these steps
                    <ul>
                      <li>5.1.1 iBeta will audit EPCS compliance every two years. In the event of losing EPCS compliant, WikiAllergies staff would follow these steps</li>
                      <li>5.1.2 Deactivate system EPCS function for all users</li>
                    </ul>
                  </li>
                  <li>5.2 When WikiAllergies reobtain EPCS certification by iBeta or when regaining EPCS compliance certificate. WikiAllergies staff would follow those instructions below
                    <ul>
                      <li>5.2.1 Notify all EPCS users that WikiAllergies EMR has regained EPCS certificate and controlled substance prescription is available for use.</li>
                      <li>5.2.2 Activate system EPCS function for previous EPCS users</li>
                    </ul>
                  </li>
                </ul>
            </div>

            <div slot="footer">
                <button @click.prevent="updateStatus()" class="btn btn-default" type="button">{{ isAllow ? 'DISABLE SYSTEM EPCS' : 'ENABLE SYSTEM EPCS' }}</button>
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import DetailRegularUserMixin from '../../../mixins/user/UserStatusMixin'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'
import httpClient from '@/client'
export default {
  name: 'ECPSInfoUser',
  mixins: [DetailRegularUserMixin, CommonMixin],
  data () {
    return {
      modal: false,
      isAllow: true
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getStatusAllowNotAllowEPCS()
  },
  beforeDestroy () {
  },
  methods: {
    closeModal () {
      this.modal = false
    },
    async getStatusAllowNotAllowEPCS () {
      let response = await httpClient.get(`/doctor/status-allow-not-allow-epcs-all`)
      try {
        if (response.data.s === 200) {
          this.isAllow = response.data.data.isAllow
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    },
    async updateStatus () {
      let response = await httpClient.post(`/doctor/allow-not-allow-epcs-all`, { isAllow: !this.isAllow })
      try {
        if (response.data.s === 200) {
          this.closeModal()
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    }
  }
}
</script>
<style scoped="">
</style>
